<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-form-reporte-nominacion"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar Reporte Nominaciones</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0 pt-1">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="Filtros">
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Fecha Inicial</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="filtros.fecha_inicial"
                        :class="
                          $v.filtros.fecha_inicial.$invalid
                            ? 'is-invalid'
                            : 'is-valid'
                        "
                        @input="validaFechas"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Fecha Final</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="filtros.fecha_final"
                        @input="validaFechas"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Tipo Informe</label>
                    <select
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_informe"
                    >
                      <option value="">Seleccione...</option>
                      <option value="1">XLSX</option>
                      <option value="2">CSV</option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Transportadora</label>
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="transportadora"
                      label="razon_social"
                      :options="listasForms.transportadoras"
                      @search="buscarTransportadoras"
                      @input="selectTransportadora()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Cliente</label>
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="cliente"
                      label="razon_social"
                      :options="listasForms.clientes"
                      @search="buscarClientes"
                      @input="selectCliente()"
                    ></v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!$v.filtros.$invalid"
            class="modal-footer justify-content-between"
          >
            <button
              type="button"
              class="btn btn-sm bg-navy"
              @click="generarListadoExcel()"
            >
              Generar Listado
              <i class="fas fa-file-download"> </i>
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";

export default {
  name: "ReporteNominacionExport",

  components: {
    Loading,
    vSelect,
  },

  data() {
    return {
      cargando: false,
      transportadora: {},
      cliente: {},
      filtros: {
        fecha_inicial: null,
        fecha_final: null,
        tipo_informe: 1,
        transportadora_id: null,
        cliente_id: null,
      },
      listasForms: {
        transportadoras: [],
        clientes: [],
      },
    };
  },

  validations: {
    filtros: {
      fecha_inicial: {
        required,
      },
    },
  },

  methods: {
    buscarTransportadoras(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url =
          "/api/argentina/empresas/lista?razon_social=" + search + "&pais_id=3";
        axios
          .get(url)
          .then((response) => {
            self.listasForms.transportadoras = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarClientes(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url =
          "/api/argentina/clientes/lista?razon_social=" + search + "&pais_id=3";
        axios
          .get(url)
          .then((response) => {
            self.listasForms.clientes = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    selectTransportadora() {
      this.filtros.transportadora_id = null;
      if (this.transportadora) {
        this.filtros.transportadora_id = this.transportadora.id;
      }
    },

    selectCliente() {
      this.filtros.cliente_id = null;
      if (this.cliente) {
        this.filtros.cliente_id = this.cliente.id;
      }
    },

    validaFechas() {
      if (this.filtros.fecha_inicial) {
        let hoy = new Date();
        let fecha_inicial = new Date(this.filtros.fecha_inicial);
        fecha_inicial.setDate(fecha_inicial.getDate());

        if (fecha_inicial >= hoy) {
          this.filtros.fecha_inicial = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial debe ser menor o igual a la fecha actual...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.filtros.fecha_inicial && this.filtros.fecha_final) {
        let fecha_menor = new Date(this.filtros.fecha_inicial);
        let fecha_mayor = new Date(this.filtros.fecha_final);
        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.filtros.fecha_final = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial no puede ser mayor a la fecha final...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/argentina/reportes/exportNominacion",
        data: { filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          if (!data.error) {
            this.$swal({
              customClass: {
                container: "my-swal",
              },
              icon: "success",
              title: data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            location.href = data.url;
          } else {
            this.$swal({
              icon: "error",
              title: data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
          this.cargando = false;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },
};
</script>
